import { addDoc, collection, deleteDoc, doc, getDocs, onSnapshot, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { docsWithId, logListenerError } from './db';

// Bookable spaces are stored in the "resources" collection; booking requests in "spaceInquiries".
const spacesCollection = () => collection(db, 'resources');
const spaceRef = (id) => doc(db, 'resources', id);

export async function listSpaces() {
  return docsWithId(await getDocs(spacesCollection()));
}

/** Live spaces owned by a business. */
export function subscribeSpacesOwnedBy(profileId, onChange, onError = logListenerError('spaces')) {
  return onSnapshot(query(spacesCollection(), where('createdBy', '==', profileId)), (snapshot) => onChange(docsWithId(snapshot)), onError);
}

export async function createSpace(ownerId, data) {
  const ref = await addDoc(spacesCollection(), { ...data, createdBy: ownerId, createdAt: Date.now(), bookedSlots: [] });
  return ref.id;
}

export function updateSpace(id, data) {
  return updateDoc(spaceRef(id), data);
}

export function deleteSpace(id) {
  return deleteDoc(spaceRef(id));
}

/** Record a confirmed booking slot on a space. */
export function addBookedSlot(space, slot) {
  return updateSpace(space.id, { bookedSlots: [...(space.bookedSlots || []), slot] });
}

// ─── Booking requests ───────────────────────────────────────────────

const inquiriesCollection = () => collection(db, 'spaceInquiries');

/** Request to book a space. applicantId must be the signed-in user's profile ID. */
export function requestSpaceBooking({ spaceId, ownerId, applicantId, applicantName, applicantEmail, requestedDate, requestedTime, message }) {
  return addDoc(inquiriesCollection(), {
    spaceId, ownerId, applicantId, applicantName, applicantEmail, requestedDate, requestedTime, message,
    status: 'pending', createdAt: Date.now(),
  });
}

/** Booking requests for one of the owner's spaces. */
export async function listBookingRequests(ownerId, spaceId) {
  return docsWithId(await getDocs(query(inquiriesCollection(), where('ownerId', '==', ownerId), where('spaceId', '==', spaceId))));
}

export function setBookingRequestStatus(id, status) {
  return updateDoc(doc(db, 'spaceInquiries', id), { status });
}
